import { StarIcon } from '@/components/icons/star-icon';
import cn from 'classnames';

type RatingProps = {
  className?: any;
  rating: number | undefined;
  variant?: 'xs' | 'small' | 'large';
};

const RatingsBadge: React.FC<RatingProps> = ({
  className = '',
  rating = 0,
  variant = 'xs',
  ...props
}) => {
  const totalStars = 5;

  const getStarType = (index: number) => {
    if (rating >= index + 1) {
      return 'full';
    } else if (rating >= index + 0.5) {
      return 'half';
    } else {
      return 'empty';
    }
  };

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-full text-white',
        {
          'px-2 py-[2px] text-sm font-semibold': variant === 'xs',
          'px-3 py-0.5 text-base': variant === 'small',
          'px-6 py-2 text-2xl font-semibold': variant === 'large',
        },
        className
      )}
      {...props}
    >
      {Array.from({ length: totalStars }, (_, index) => {
        const starType = getStarType(index);
        return (
          <StarIcon
            key={index}
            className={cn(
              {
                'mr-1 h-2.5 w-2.5': variant === 'xs',
                'mr-1.5 h-3 w-3': variant === 'small',
                'mr-2 h-5 w-5': variant === 'large',
                'mr-0': index === 0,
              },
              starType === 'full'
                ? 'text-brand'
                : starType === 'half'
                ? 'text-brand'
                : 'text-gray-300'
            )}
            style={{
              maskImage:
                starType === 'half'
                  ? 'linear-gradient(90deg, black 50%, transparent 50%)'
                  : undefined,
              WebkitMaskImage:
                starType === 'half'
                  ? 'linear-gradient(90deg, black 50%, transparent 50%)'
                  : undefined,
            }}
          />
        );
      })}
    </span>
  );
};

export default RatingsBadge;
